import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TasksTableRow } from "../types";

export const useTasksNavigation = (row: TasksTableRow) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOnClick = useCallback(() => {
    navigate(`/new-premise/${row.id}?connection=${row.connectionType}`, {
      state: {
        backUrl: location.pathname + location.search,
      },
    });
  }, [row]);

  return {
    handleOnClick,
    navigate,
    location,
  };
};
